import { action, makeObservable, observable } from 'mobx'

import { IProjectClosedInterval } from '~/client/graph'
import TwoMonthsDatePickerStore, {
  ITwoMonthsDatePickerOptions,
} from '~/client/src/desktop/components/TwoMonthsDatePicker/TwoMonthsDatePicker.store'
import Project from '~/client/src/shared/models/Project'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

interface IClosuresDatePickerStoreOptions extends ITwoMonthsDatePickerOptions {
  activeProject?: Project
  onRemove?: (item: Project, interval: IProjectClosedInterval) => void
  /** Seeds the name field when reopening the picker on an existing closure. */
  intervalName?: string
}

export default class ClosuresDatePickerStore extends TwoMonthsDatePickerStore {
  @observable public intevalName: string = ''
  @observable public closedIntervals = null
  @observable public project: Project = null
  public onRemove

  protected onApplyHandler: (
    startDate: Date,
    endDate: Date,
    intervalName?: string,
  ) => void

  public constructor(
    projectDateStore: ProjectDateStore,
    onShowChanged?: (isShown: boolean) => void,
  ) {
    super(projectDateStore, onShowChanged)

    makeObservable(this)
  }

  public showWithOptions(options: IClosuresDatePickerStoreOptions) {
    const { onRemove, activeProject, intervalName } = options
    this.project = activeProject
    this.onRemove = onRemove
    this.setIntervalName(intervalName || '')

    super.showWithOptions(options)
  }

  @action.bound
  private setIntervalName(name: string) {
    this.intevalName = name
  }

  @action.bound
  public onIntevalNameChange(event) {
    this.intevalName = event.target.value
  }

  public applySelectedDates() {
    if (this.onApplyHandler) {
      this.onApplyHandler(this.startDate, this.endDate, this.intevalName)
    }
  }
}
